import { useAppSelector } from '@hooks/reduxHooks';
import { baseErrorHandler } from '@queries/baseErrorHandler';
import i18n from '@service/I18nService';
import { $api } from '@service/RequestService';
import { useMutation } from 'react-query';

import { endPoints } from '../utils/constants/endPoints';

export function useShowroomTableExcel() {
  const { filter } = useAppSelector(state => state.showroomSlice);

  return useMutation(
    async () => {
      const res = await $api.post(
        `${endPoints.SMART_CATALOG_TABLE_EXCEL}?lang=${i18n.language?.toUpperCase()}`,
        filter,
        {
          responseType: 'blob'
        }
      );

      return res.data;
    },
    {
      onSuccess: () => {
        // downloadFile(data, `Xonadonlar-${dayjs(Date.now()).format('DD-MM-YYYY')}`, 'xlsx');
      },
      onError: baseErrorHandler
    }
  );
}

export function useShowroomTableSummaryExcel() {
  const { filter } = useAppSelector(state => state.showroomSlice);

  return useMutation(
    async () => {
      const res = await $api.post(
        `${endPoints.SMART_CATALOG_TABLE_SUMMARY_EXCEL}?lang=${i18n.language?.toUpperCase()}`,
        filter,
        {
          responseType: 'blob'
        }
      );

      return res.data;
    },
    {
      onSuccess: () => {
        // downloadFile(data, `Xonadonlar-${dayjs(Date.now()).format('DD-MM-YYYY')}`, 'xlsx');
      },
      onError: baseErrorHandler
    }
  );
}

export function useShowroomTableSummaryExcelBeta() {
  const { filter } = useAppSelector(state => state.showroomSlice);

  return useMutation(
    async () => {
      const res = await $api.post(
        `${endPoints.SMART_CATALOG_TABLE_SUMMARY_EXCEL_BETA}?lang=${i18n.language?.toUpperCase()}`,
        filter,
        {
          responseType: 'blob'
        }
      );

      return res.data;
    },
    {
      onSuccess: () => {
        // downloadFile(data, `Xonadonlar-${dayjs(Date.now()).format('DD-MM-YYYY')}`, 'xlsx');
      },
      onError: baseErrorHandler
    }
  );
}
